import { branch, renderComponent } from 'react-recompose';
import { SkeletonVizLoader } from '../loaders/skeleton-viz-loader';

export default (propName = 'loading') => {
  return branch(
    props => props[propName],
    renderComponent(() => <SkeletonVizLoader />),
  );
};
